import Vue from "vue";
import Vuex from "vuex";
import NavSidebarStore from "./nav-sidebar.store";
import RecognitionAnalyticsStore from "./recognition-analytics.store";
import InvoiceVolumeAnalyticsStore from "./invoice-volume-analytics.store";
import InvoicesAnalyticsStore from "./invoices-analytics.store";
import AnalyticsStore from "./analytics.store";
import AuthStore from "./auth.store";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    NavSidebarStore,
    RecognitionAnalyticsStore,
    InvoiceVolumeAnalyticsStore,
    InvoicesAnalyticsStore,
    AnalyticsStore,
    AuthStore
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: [
        "AuthStore.userIsAuthenticated",
        "AuthStore.signedInUser",
        "AuthStore.sites",
        "AuthStore.accessToken",
        "AuthStore.launchDarklyUser",
        "AuthStore.launchDarklyFlags"
      ]
    })
  ]
});
